import { useState, FormEvent } from "react";

const ADMIN_PASSWORD = "12341234";
const SESSION_KEY = "admin_authenticated";

interface AdminLoginProps {
  onAuthenticated: () => void;
}

export default function AdminLogin({ onAuthenticated }: AdminLoginProps) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    setTimeout(() => {
      if (password === ADMIN_PASSWORD) {
        sessionStorage.setItem(SESSION_KEY, "true");
        onAuthenticated();
      } else {
        setError("비밀번호가 올바르지 않습니다.");
        setPassword("");
      }
      setIsLoading(false);
    }, 600);
  };

  return (
    <div className="min-h-screen bg-[#f7f6f3] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo / Title */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#e8a87c] rounded-2xl mb-5">
            <i className="ri-shield-keyhole-line text-white text-2xl"></i>
          </div>
          <h1 className="text-2xl font-bold text-[#2d2a26] tracking-tight">관리자 로그인</h1>
          <p className="text-sm text-[#9a9187] mt-2">제주 스테이 관리자 전용 페이지입니다</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl p-8 border border-[#ede9e3]">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-[#2d2a26] mb-2">
                관리자 비밀번호
              </label>
              <div className="relative">
                <div className="absolute left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#9a9187]">
                  <i className="ri-lock-line text-base"></i>
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError("");
                  }}
                  placeholder="비밀번호를 입력하세요"
                  className={`w-full pl-10 pr-12 py-3 text-sm bg-[#f7f6f3] border rounded-xl outline-none transition-all
                    ${error
                      ? "border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                      : "border-[#ede9e3] focus:border-[#e8a87c] focus:ring-2 focus:ring-[#e8a87c]/20"
                    }`}
                  autoFocus
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                  className="absolute right-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#9a9187] hover:text-[#2d2a26] transition-colors cursor-pointer"
                >
                  <i className={showPassword ? "ri-eye-off-line text-base" : "ri-eye-line text-base"}></i>
                </button>
              </div>
              {error && (
                <div className="flex items-center gap-1.5 mt-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-error-warning-line text-red-500 text-sm"></i>
                  </div>
                  <p className="text-xs text-red-500">{error}</p>
                </div>
              )}
            </div>

            <button
              type="submit"
              disabled={isLoading || !password}
              className="w-full py-3 bg-[#e8a87c] text-white text-sm font-semibold rounded-xl
                hover:bg-[#d4946a] active:scale-[0.98] transition-all disabled:opacity-50
                disabled:cursor-not-allowed flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              {isLoading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"></div>
                  <span>확인 중...</span>
                </>
              ) : (
                <>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-login-box-line text-base"></i>
                  </div>
                  <span>로그인</span>
                </>
              )}
            </button>
          </form>
        </div>

        {/* Footer note */}
        <p className="text-center text-xs text-[#b8b0a6] mt-6">
          관리자 비밀번호를 잊으셨나요? 개발자에게 문의하세요.
        </p>
      </div>
    </div>
  );
}

export { SESSION_KEY };
